<div class="detailsPage">
    <div class="breadCrumbCont">
        <a class="breadCrumbLink" [routerLink]="['/app']">
            Applications
        </a>
        <p>/</p>
        <a class="breadCrumbLink current">
            {{ product.moduleName }}
        </a>
    </div>
    <div class="contentCard">
        <p *ngIf="!product">Loading Applications...</p>
        <div class="products colforDetails" *ngIf="product">
            <div class="banner new">
                <div class="main">
                    <img [src]="(moduleByteMap[product.moduleName] 
                || moduleByteMap['Tyre Pairing']) | base64: 'image/png'" [alt]="product.moduleName">
                    <div *ngIf="false" class="otherImages">
                        <img src="/assets/images/DeepDiveTool_MainView.png" alt="">
                        <img src="/assets/images/DeepDiveTool_MainView.png" alt="">
                        <img src="/assets/images/DeepDiveTool_MainView.png" alt="">
                    </div>
                </div>
                <p *ngIf="false" style="color: #525252 ; margin: 0px auto; margin-top: 1rem; width: fit-content;">Last Refreshed: <span>2hrs ago</span></p>
                <div class="actionBtnsCont">
                    <button class="secondary" *ngIf="!userId && !isUserLoggedIn&&product.moduleLink"
                                       (click)="onSignIn()">
                                       <img src="/assets/images/locked.svg" alt="">
                                         Request Access
                    </button>

                    <button class="primary" *ngIf="product.subscription && userId && isUserLoggedIn" (click)="onApplicationsApicall(product.moduleLink)">
                                         Open Application
                    </button>
                    <button class="secondary"
                                        *ngIf="product.subscription == false&&product.moduleLink&& product.accessCompleted == undefined &&userId &&isUserLoggedIn"
                                        (click)="product.moduleName=='Data Portal' ? onRequestAccessClick(product) : onSubscribe()">
                                        <img src="/assets/images/locked.svg" alt="" />
                                        Request Access
                    </button>

                    <button class="secondary"
                                        *ngIf="product.subscription == false&& product.accessCompleted != undefined && product.accessCompleted == false && userId &&isUserLoggedIn"
                                        (click)="onAccessPending()">
                                        <img src="/assets/images/locked.svg" alt="" />
                                        Access Pending
                    </button>
                                  
                   
                    <div class="iconBtn">
                        <img (click)="shareLink()" src="/assets/images/copyLink.svg" alt="" style="cursor: pointer;border-radius: 0">
                    </div>
                    <p id="copyMsg" class="copyMsg" >
                                Link Copied!
                    </p>
                    <!-- <div class="iconBtn" (click)="product.isBookmarked = !product.isBookmarked">
                        <img class="" *ngIf="!product.isBookmarked" src="/assets/images/bookmarksIcon.svg" alt="" style="width: 32px; padding: 6px 0;">
                        <img class="" *ngIf="product.isBookmarked" src="/assets/images/bookmarksIcon-filled.svg" style="width: 14px; padding: 6px 0;" alt="">
                    </div> -->
                </div>
            </div>
            <div class="productCard detailsCont">
                <div class="productCardContent flexSP gridForName">
                    <h1>{{ product.moduleName }}</h1>
                    <p *ngIf="product.moduleLink == ''" class="tag new floating justStart">Coming Soon</p>
                </div>
                <div class="staticTags flexSP justStart">
                        <p class="tag" *ngFor="let tag of product?.tags" class="tag">{{  tag.tagName }}</p>
                </div>
               

                <div class="detailGroup">
                    <h3>Objective</h3>
                    <p>{{product.moduleLongDescription}}</p>
                </div>
                
                <div class="detailGroup staticTags">
                    <h3>Features <span>(What will you get)</span></h3>
                    <div class="featureGrid">
                        <p class="" *ngFor="let feature of product?.features"><span><img src="/assets/images/Check.svg" alt=""></span>{{feature}}</p>
                    </div>
                </div>
                <div class="supportCont">
                    <div class="flexSP justStart">
                        <div class="sectionHead">
                            <h2>Need more details?</h2>
                            <p>Connect with the product owner</p>
                        </div>
                        <div class="buttonsCont">
                            <img (click)="redirectToEmail()" src="/assets/images/contactOwnerMail.svg" alt="" style="cursor: pointer;">
                            <img *ngIf="false" src="/assets/images/contactOwnerTeams.svg" alt="">
                            <button *ngIf="false" class="secondary">Request Demo</button>
                        </div> 
                    </div>

                    <img src="/assets/images/dmint_customer_care_illiustration.svg" class="illus" alt="">
                </div>
            </div>
            
        </div>
    </div>
</div>
<app-success-toast [message]="successMessage" *ngIf="successMessage"></app-success-toast>

<app-alert [message]="errMsg" *ngIf="showErrorMessageWithPopup" (close)="onCloseHandlerSub()"></app-alert>